import React from 'react';
import { createPortal } from 'react-dom';
import './ImportResultModal.css';

export interface ImportNotProcessedItem {
  row: number;
  data: string;
  reason: string;
}

export interface ImportResultModalProps {
  isOpen: boolean;
  processed: number;
  notProcessed: ImportNotProcessedItem[];
  onClose: () => void;
}

export const ImportResultModal: React.FC<ImportResultModalProps> = ({
  isOpen,
  processed,
  notProcessed,
  onClose
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="import-result-modal-overlay" onClick={onClose}>
      <div className="import-result-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="import-result-modal-header">
          <h3>Import Complete</h3>
          <button
            className="import-result-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        <div className="import-result-modal-body">
          <p className="import-result-modal-summary">
            <strong>{processed}</strong> record{processed !== 1 ? 's' : ''} processed successfully.
          </p>
          {notProcessed.length > 0 && (
            <div className="import-result-modal-not-processed">
              <h4>{notProcessed.length} record{notProcessed.length !== 1 ? 's' : ''} not processed</h4>
              <ul className="import-result-modal-list">
                {notProcessed.map((item, idx) => (
                  <li key={idx} className="import-result-modal-item">
                    <span className="import-result-modal-item-row">Row {item.row}:</span>
                    <span className="import-result-modal-item-data">{item.data}</span>
                    <span className="import-result-modal-item-reason">— {item.reason}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="import-result-modal-footer">
          <button
            className="app-btn app-btn-primary"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
